module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-body', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-left": "10px",
      "padding-top": "10px",
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "起始日期:"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.startDate),
      callback: function($$v) {
        _vm.startDate = $$v
      },
      expression: "startDate"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "终止日期:"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.endDate),
      callback: function($$v) {
        _vm.endDate = $$v
      },
      expression: "endDate"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "销售客户"
    },
    on: {
      "change": _vm.getSales
    },
    model: {
      value: (_vm.salesCustomer),
      callback: function($$v) {
        _vm.salesCustomer = $$v
      },
      expression: "salesCustomer"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-select', {
    staticStyle: {
      "margin-bottom": "20px",
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "filterable": "",
      "clearable": "",
      "remote": "",
      "placeholder": "请输入商品名称",
      "remote-method": _vm.remoteMethod
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.label,
        "value": item.key
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "type": "primary",
      "icon": "search"
    },
    on: {
      "click": function($event) {
        return _vm.getSales()
      }
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('el-button', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "type": "primary",
      "icon": "document"
    },
    on: {
      "click": _vm.handleDownload
    }
  }, [_vm._v("导出excel")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.sales,
      "border": "",
      "stripe": "",
      "search-def": _vm.getSearchDef(),
      "highlight-current-row": ""
    },
    on: {
      "selection-change": _vm.selsChange,
      "row-click": _vm.rowClick
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "65"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "itemNo",
      "label": "商品编号",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "itemName",
      "label": "商品名称",
      "min-width": "150",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "spec",
      "label": "商品规格",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "manufacture",
      "label": "生产厂家",
      "min-width": "210",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "unit",
      "label": "单位",
      "width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "customerNo",
      "label": "客户编码",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "customerName",
      "label": "客户名称",
      "min-width": "150",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "salesQty",
      "label": "销售数量",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "batchNo",
      "label": "批号",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "salesDate",
      "label": "销售日期",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "salesName",
      "label": "销售员",
      "width": "100",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "label": "送货地址",
      "min-width": "150",
      "sortable": ""
    }
  }), _vm._v(" "), (_vm.userInfo.showMoney) ? _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "含税单价",
      "width": "100"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.userInfo.showMoney) ? _c('el-table-column', {
    attrs: {
      "prop": "number",
      "label": "含税金额",
      "width": "100"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "department",
      "label": "部门",
      "width": "100"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "current-page": _vm.page,
      "page-sizes": [5, 10, 15, 20, 50],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "width": "90%",
      "top": "2%",
      "show-close": true,
      "fullscreen": true
    },
    model: {
      value: (_vm.viewVisible),
      callback: function($$v) {
        _vm.viewVisible = $$v
      },
      expression: "viewVisible"
    }
  }, [_c('el-form', {
    ref: "resetForm",
    staticClass: "table-expand",
    attrs: {
      "model": _vm.sales,
      "label-width": "70px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "商品名称"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.selectRow.itemName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品规格"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.selectRow.spec))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "单位"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.selectRow.unit))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "生产厂家"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.selectRow.manufacture))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "客户名称"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.selectRow.customerName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "销售数量"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.selectRow.salesQty))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "批号"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.selectRow.batchNo))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "销售日期"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.selectRow.salesDate))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "销售员"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.selectRow.salesName))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.viewVisible = false
      }
    }
  }, [_vm._v("返回")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1b1b02fb!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/SalesTable.vue
// module id = 1756
// module chunks = 2